import { selectIsMinimalistic, useAppSelector } from '@/app/store';

export const BrandTgLogo = () => {
  const tg = window.Telegram?.WebApp;
  const version = tg ? parseFloat(tg.version) : 0;
  const isMinimalistic = useAppSelector(selectIsMinimalistic);
  const brandLogo = useAppSelector((state) => state.initial.brendLogo);
  const showBrandLogo = useAppSelector((state) => state.initial.settings.showBrandLogo);

  const topContentInset = version >= 8.0 && tg ? tg.safeAreaInset.top : 0;

  if (!tg || !document.body.classList.contains('full-screen') || !brandLogo || !showBrandLogo || isMinimalistic)
    return null;

  return (
    <img
      width={130}
      height={32}
      alt='Brand Logo'
      style={{ top: `${topContentInset + 7}px` }}
      className='absolute left-[50%] -translate-x-1/2 z-10 max-w-[130px] max-h-[32px]'
      src={`${import.meta.env.VITE_API_MINIO_URL}/${brandLogo.bucketName}/${brandLogo.originalObjectName}`}
    />
  );
};
